/**
 * Azhara lead capture (SPEC 3.2)
 *
 * window.AzharaLeads.capture({
 *   source: 'gifting' | 'custom-fragrance' | 'business-scenting' | 'contact' | 'vibe-quiz' | string,
 *   name: '', phone: '', email: '',     // phone OR email required
 *   message: '',                        // human-readable summary
 *   payload: {},                        // structured answers
 *   whatsapp_text: '',                  // exact WA prefill (optional)
 *   skip_fbq: false                     // set true when the caller already fires fbq Lead
 * }) -> Promise<{ ok: boolean, id?: string }>
 *
 * Never rejects, never throws, resolves within ~2.5 s. Stores the lead as a Shopify
 * metaobject (type "lead") through the azhara-lead-bridge Cloudflare Worker, then
 * fires fbq('track', 'Lead') once on success. Callers open WhatsApp after it settles:
 *
 *   var go = function () { window.open(waUrl, '_blank', 'noopener'); };
 *   (window.AzharaLeads ? AzharaLeads.capture(data) : Promise.resolve()).then(go, go);
 */
(function () {
  'use strict';

  var VERSION = '1.0.0';
  var DEFAULT_ENDPOINT = 'https://azhara-lead-bridge.purandare-sarang.workers.dev/lead';
  var TIMEOUT_MS = 2500;
  var DEDUPE_MS = 10000;
  var recent = {};

  function endpoint() {
    var o = window.AZHARA_LEAD_ENDPOINT;
    return (typeof o === 'string' && o) ? o : DEFAULT_ENDPOINT;
  }

  function str(v, max) {
    if (v === null || v === undefined) return '';
    v = String(v).trim();
    return v.length > max ? v.slice(0, max) : v;
  }

  function utmParams() {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (/^utm_/i.test(key)) out[key.toLowerCase()] = str(value, 200);
      });
    } catch (e) { /* ignore */ }
    return out;
  }

  function build(input) {
    var payload = (input.payload && typeof input.payload === 'object') ? input.payload : {};
    return {
      source: str(input.source, 40).toLowerCase(),
      name: str(input.name, 120),
      phone: str(input.phone, 32),
      email: str(input.email, 254),
      message: str(input.message, 4000),
      whatsapp_text: str(input.whatsapp_text, 4000),
      payload: payload,
      page_url: str(window.location.href, 2048),
      referrer: str(document.referrer, 2048),
      utm: utmParams(),
      user_agent: str(navigator.userAgent, 250),
      website: str(input.website, 200)
    };
  }

  function isDuplicate(body) {
    var key;
    try {
      key = JSON.stringify([body.source, body.name, body.phone, body.email, body.message, body.payload]);
    } catch (e) {
      return false;
    }
    var now = Date.now();
    for (var k in recent) {
      if (recent.hasOwnProperty(k) && now - recent[k] > DEDUPE_MS) delete recent[k];
    }
    if (recent[key] && now - recent[key] < DEDUPE_MS) return true;
    recent[key] = now;
    return false;
  }

  function fireLead() {
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead');
    } catch (e) { /* ignore */ }
  }

  function capture(input) {
    try {
      input = input || {};
      var body = build(input);
      if (isDuplicate(body)) return Promise.resolve({ ok: true, deduped: true });
      if (typeof window.fetch !== 'function') return Promise.resolve({ ok: false });

      var controller = (typeof AbortController === 'function') ? new AbortController() : null;
      var timer = setTimeout(function () { if (controller) controller.abort(); }, TIMEOUT_MS);

      var request = fetch(endpoint(), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined
      }).then(function (res) {
        return res.json().then(function (json) { return json; }, function () { return { ok: res.ok }; });
      }).then(function (json) {
        var ok = !!(json && json.ok);
        if (ok && !input.skip_fbq) fireLead();
        return ok ? { ok: true, id: json.id } : { ok: false, error: json && json.error };
      }).catch(function () {
        return { ok: false };
      });

      var deadline = new Promise(function (resolve) {
        setTimeout(function () { resolve({ ok: false, timeout: true }); }, TIMEOUT_MS + 100);
      });

      return Promise.race([request, deadline]).then(function (result) {
        clearTimeout(timer);
        return result;
      }, function () {
        clearTimeout(timer);
        return { ok: false };
      });
    } catch (e) {
      return Promise.resolve({ ok: false });
    }
  }

  window.AzharaLeads = { capture: capture, version: VERSION };
})();
